import { useContext } from 'react';
import { notNull } from 'utils/notNull';
import { SiteInfoContext } from './SiteInfoContext';

export function useSiteInfo() {
  const { siteInfoQuery } = useContext(SiteInfoContext);
  // наличие значения гарантируется тем, что данный хук используется только в компонентах, обернутых SiteInfoProvider
  return notNull(siteInfoQuery);
}
